import groupIcon from "../assets/images/chats/Group_empty.svg";
import personFloatIcon from "../assets/images/chats/personFloatBtn.svg";
import fileIcon from "../assets/images/chats/file_icon.svg";
import starredIcon from "../assets/images/chats/starred_icon.svg";
import unstarIcon from "../assets/images/chats/unstar_icon.svg";

// Registry of the chat header's pinnable shortcut icons — dragged from the
// "More" popover onto the chat screen header, up to MAX_PINNED_SHORTCUTS at
// a time. `activeIcon` (Star Messages only) swaps in while that shortcut's
// feature is toggled on.
export const CHAT_SHORTCUTS = [
  { id: "members", label: "Group Members", icon: groupIcon },
  { id: "addMember", label: "Add Group Members", icon: personFloatIcon },
  { id: "files", label: "Group Files", icon: fileIcon },
  { id: "star", label: "Star Messages", icon: unstarIcon, activeIcon: starredIcon },
];

export const getChatShortcutMeta = (id) =>
  CHAT_SHORTCUTS.find((shortcut) => shortcut.id === id);

export const MAX_PINNED_SHORTCUTS = 4;

export const DEFAULT_PINNED_SHORTCUTS = ["addMember", "star", "files"];

export const PINNED_SHORTCUTS_DROPZONE_ID = "chat-pinned-shortcuts-dropzone";
